import React from "react";
import LightBoard from "./LightBoard";
import DarkBoard from "./DarkBoard";

const FIELD_SCALE = 1.15;
const vh = (n) => +(n * FIELD_SCALE).toFixed(3) + "vh";

const cfg = {
  pad: "3vh 3vw",
  iconSize: vh(4.15),
  iconBox: vh(7),
  titleSize: vh(5.7),
  airportSize: vh(2.5),
  clockSize: vh(2.85),
  headSize: vh(1.9),
  rowSize: vh(3),
  badgeSize: vh(4),
  badgeFont: vh(1.55),
  cols: "8% 9% 12% 44% 12% 15%",
  dualPad: "1.8vh 1.6vw",
  dualDir: "row",
  dualCols: "12% 15% 39% 14% 20%",
  dualTitleSize: vh(3.6),
  dualAirportSize: vh(1.6),
  dualClockSize: vh(2),
  dualHeadSize: vh(1.3),
  dualRowSize: vh(1.9),
  dualBadgeSize: vh(2.6),
  dualBadgeFont: vh(1.1),
  dualIconBox: vh(4.5),
  dualIconSize: vh(3),
  dualRowMin: vh(3.2),
  sectionIconBox: vh(2.6),
  sectionIconSize: vh(1.8),
  sectionTitleSize: vh(1.6),
  statusColWidth: "14%",
};

const Square = (props) => {
  const Board = props.theme === "dark" ? DarkBoard : LightBoard;
  return <Board {...props} cfg={cfg} />;
};

export default Square;
